module.exports = __webpack_public_path__ + "static/media/map-example.8786b941.jpg";